import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
const articles = [{
  id: 1,
  title: '10 Essential Tips for Budget Travel',
  excerpt: 'Learn how to make the most of your vacation without breaking the bank with these money-saving travel tips.',
  image: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1935&q=80',
  category: 'Budget Travel',
  readTime: '5 min read'
}, {
  id: 2,
  title: 'The Best Time to Book Flights for Maximum Savings',
  excerpt: 'Timing is everything when it comes to finding flight deals. Discover the optimal booking windows for your next trip.',
  image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80',
  category: 'Flight Tips',
  readTime: '4 min read'
}, {
  id: 3,
  title: 'Packing Essentials for Every Type of Vacation',
  excerpt: "Whether you', re, heading, to, the, beach, or, exploring, a, new: city, here, 's what you need to pack for a stress-free trip.':",
  image: 'https://images.unsplash.com/photo-1523293182086-7651a899d37f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  category: 'Travel Advice',
  readTime: '6 min read'
}];
const TravelTips = () => {
  return <section className="py-12 bg-white" data-id="element-187">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
        <div className="text-center mb-12" data-id="element-189">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-190">
            Travel Tips & Inspiration
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-191">
            Expert advice to help you travel smarter and explore the world
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-192">
          {articles.map(article => <div key={article.id} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-193">
              <img src={article.image} alt={article.title} className="w-full h-48 object-cover" data-id="element-194" />
              <div className="p-6" data-id="element-195">
                <div className="flex items-center mb-2" data-id="element-196">
                  <span className="text-xs font-medium bg-blue-50 text-blue-700 px-2 py-1 rounded-full" data-id="element-197">
                    {article.category}
                  </span>
                  <span className="text-xs text-gray-500 ml-2" data-id="element-198">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-199">
                  {article.title}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-200">{article.excerpt}</p>
                <Link to="/" className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800" data-id="element-201">
                  Read more
                  <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-202" />
                </Link>
              </div>
            </div>)}
        </div>
        <div className="mt-10 text-center" data-id="element-203">
          <Link to="/" className="text-blue-600 font-medium hover:text-blue-800" data-id="element-204">
            View all travel tips
          </Link>
        </div>
      </div>
    </section>;
};
export default TravelTips;